import { render, staticRenderFns } from "./game-design-tool.vue?vue&type=template&id=1db12be4&scoped=true&"
import script from "./game-design-tool.vue?vue&type=script&lang=ts&"
export * from "./game-design-tool.vue?vue&type=script&lang=ts&"
import style0 from "./game-design-tool.vue?vue&type=style&index=0&id=1db12be4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db12be4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogAcfBlocks: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/BlogAcfBlocks.vue').default})
